var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGridPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "grid_logo",
    "data-name": "grid + logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 110 34.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logo",
    "data-name": "Subtraction 20",
    d: "M15.132,28.573a17.514,17.514,0,0,1-6.039-1.027A14.248,14.248,0,0,1,4.3,24.657,13.02,13.02,0,0,1,1.14,20.2,14.46,14.46,0,0,1,0,14.45C0,6.077,6.4,0,15.212,0a15.37,15.37,0,0,1,9.32,2.778s0,.006,0,.013c-.051.127-.675,1.14-1.264,2.074s-1.2,1.885-1.237,1.885a10.479,10.479,0,0,0-6.575-2.175c-6,0-10.2,4.06-10.2,9.874C5.258,20.071,9.434,24,15.413,24a8.878,8.878,0,0,0,5.127-1.119V14.45h4.937V25.327A13.712,13.712,0,0,1,20.7,27.838,19.231,19.231,0,0,1,15.132,28.573ZM38.939,28.5H33.721V.075h9.928A13.08,13.08,0,0,1,52.4,2.9,9.606,9.606,0,0,1,55.61,10.4a8.974,8.974,0,0,1-5.98,8.871L56.092,28.5H50.146l-5.74-8.228a9.811,9.811,0,0,1-1.084.04H38.939V28.5Zm0-23.682V15.689h4.469c3.939,0,6.291-1.979,6.291-5.293,0-2.7-1.653-5.579-6.291-5.579ZM88.624,28.5H77.974V.075H88.789V4.821c-.129,0-.265,0-.405,0H83.518l0,19.117h4.866c6.561,0,9.92-3.13,9.985-9.3h5.259a17.492,17.492,0,0,1-1.1,6.338,10.873,10.873,0,0,1-3.032,4.3,12.542,12.542,0,0,1-4.717,2.45A22.31,22.31,0,0,1,88.624,28.5Zm-19.617,0H63.463V.075h5.544Z",
    transform: "translate(0 6.419)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "decoration",
    "data-name": "Union 22",
    d: "M6.363,17.621V11.258H0V6.363H6.363V0h4.895V6.363h6.363v4.895H11.258v6.363Z",
    transform: "translate(92.379)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridPlus);
export default __webpack_public_path__ + "static/media/grid-plus.916e1eee.svg";
export { ForwardRef as ReactComponent };